import React from 'react';
import { useBranding } from '../context/BrandingContext';

/**
 * Single source of truth for the site logo. Renders either the custom uploaded
 * logo (from BrandingContext) or a text placeholder — never both. Height comes
 * from the parent via className (default `h-14`).
 */
const Logo = ({
  className = 'h-14 w-auto',
  variant = 'dark',
  placeholder = 'Humanistix',
  showPill = true,
}) => {
  const { logoDataUrl } = useBranding();

  if (logoDataUrl) {
    return (
      <img
        src={logoDataUrl}
        alt="Humanistix logo"
        className={className}
        data-testid="site-logo-image"
      />
    );
  }

  const textColor = variant === 'light' ? 'text-white' : 'text-slate-900';
  const pillBg = variant === 'light' ? 'bg-white/15 text-white/90' : 'bg-blue-100 text-blue-700';

  return (
    <span
      className={`inline-flex items-center gap-1.5 font-bold text-base tracking-tight ${textColor}`}
      data-testid="site-logo-placeholder"
    >
      {placeholder}
      {showPill && (
        <span className={`text-[9px] font-semibold px-1.5 py-0.5 rounded-full ${pillBg}`}>
          AI for HR
        </span>
      )}
    </span>
  );
};

export default Logo;
